import * as Yup from 'yup'
import { EMAIL_REGEX, MIN_PASSWORD_LENGTH } from '../utils/constants';
import { CommonMessages } from '../messages/validationMessages';


// Forgot password form validation schema.
export const addadminuserSchema = Yup.object({
    permissionType: Yup.string().required(CommonMessages.permission_required),
    name: Yup.string().required(CommonMessages.name_required),
    email: Yup
        .string()
        .trim()
        .matches(EMAIL_REGEX, CommonMessages.email_invalid)
        .required(CommonMessages.email_required),
    password: Yup.string().trim().min(MIN_PASSWORD_LENGTH, CommonMessages.password_minimum).required(CommonMessages.password_required),
    repassword: Yup.string().trim().oneOf([Yup.ref('password')], CommonMessages.password_match).required(CommonMessages.password_required),

});